import React from 'react';
import { motion } from 'motion/react';
import { Button } from '@/components/ui/Button';

interface MainErrorProps {
  statusMessage: string | null;
  onDismiss: () => void;
}

export const MainError = ({ statusMessage, onDismiss }: MainErrorProps) => {
  return (
    <motion.div 
      key="error" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.2 }}
      className="flex flex-col items-center justify-center h-[60vh] max-w-md mx-auto text-center"
    >
      <div className="w-16 h-16 rounded-full bg-rose-100 dark:bg-rose-900/30 flex items-center justify-center mb-6">
        <span className="text-2xl">⚠️</span>
      </div>
      <h3 className="text-xl font-semibold text-slate-800 dark:text-slate-200 mb-3">Analysis Failed</h3>
      <p className="text-sm text-slate-700 dark:text-slate-400 bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-800 rounded-lg p-4 font-mono leading-relaxed">
        {statusMessage}
      </p>
      <Button variant="primary" onClick={onDismiss} className="mt-8 bg-slate-800 dark:bg-slate-700 hover:bg-slate-700 dark:hover:bg-slate-600 border-none px-6">
        Dismiss Error
      </Button>
    </motion.div>
  );
};
